import React from 'react';
import { useLocation } from 'react-router-dom';

import { usePatient } from 'hooks/usePatient/usePatient';
import { PatientStateModal } from 'screens/PatientStateModal/PatientStateModal';
import { RoutesPath } from 'utilities/pageUrl';

import { shouldOpenPatientStateModal, isOnConfirmationPage } from './InitialModal.utils';

export const InitialModal = () => {
  const location = useLocation();
  const { patient, loading: patientLoading } = usePatient();
  const openPatientStateModal = shouldOpenPatientStateModal(patient);
  const isConsentPage = location.pathname.startsWith(RoutesPath.CONSENTS);
  const isConfirmationPage = isOnConfirmationPage(location.pathname);
  const isOnBookingPage = location.pathname.startsWith('/booking/book');

  if (isConsentPage || isConfirmationPage || isOnBookingPage) return <></>;

  if (openPatientStateModal && !patientLoading) {
    return <PatientStateModal open={openPatientStateModal} />;
  }

  return <></>;
};
